
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { Switch } from "@/components/ui/switch";
import { Label } from "@/components/ui/label";

export default function NotificationsSettings() {
  return (
    <Card>
      <CardHeader>
        <CardTitle>Configurações de Notificações</CardTitle>
      </CardHeader>
      <CardContent className="space-y-6">
        <div className="flex items-center justify-between">
          <Label htmlFor="email-notifications">Notificações por Email</Label>
          <Switch id="email-notifications" />
        </div>
        <div className="flex items-center justify-between">
          <Label htmlFor="transaction-alerts">Alertas de Transações</Label>
          <Switch id="transaction-alerts" />
        </div>
        <div className="flex items-center justify-between">
          <Label htmlFor="balance-alerts">Alertas de Saldo</Label>
          <Switch id="balance-alerts" />
        </div>
      </CardContent>
    </Card>
  );
}
